import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { updateStationGroupAdmin } from '../../store/slices/invitesSlice';

const RoleMangement = ({ show, onClose, row }) => {
    const dispatch = useDispatch();

    const { stationsList, error, loading, meta } = useSelector((state) => state.invites);

    const [isGroupAdmin, setIsGroupAdmin] = useState(false);
    const [selectedStationGroups, setSelectedStationGroups] = useState([]);

    // Get existing values from row
    const existingIsStationAdmin =row?.attributes?.metadata?.["3"]?.isStationAdmin || false;
    const existingAllotedStationGroups =row?.attributes?.metadata?.["3"]?.allotedStationGroups || false;
    const existingRoles =row?.attributes?.metadata?.["1"]?.api?.roles || [];

    const stationGroupsList = useMemo(() => 
        stationsList.map((app) => ({
            label: app,
            value: app,
        }))
    , [stationsList]);

    // Initialize from row values when modal opens
    useEffect(() => {
        if (!show) return;

        // Set toggle based on existing isStationAdmin value
        setIsGroupAdmin(existingIsStationAdmin);

        // Parse and set selected stations from allotedStationGroups
        if (existingIsStationAdmin && existingAllotedStationGroups && stationsList.length > 0) {
            const stationArray = existingAllotedStationGroups.split(',').map(s => s.trim()).filter(Boolean);
            
            const selected = stationGroupsList.filter((option) => 
                stationArray.some(station => String(station) === String(option.value))
            );

            setSelectedStationGroups(selected);
        } else {
            setSelectedStationGroups([]);
        }
    }, [show, existingIsStationAdmin, existingAllotedStationGroups, stationsList, stationGroupsList]);

    const handleToggle = useCallback((checked) => {
        setIsGroupAdmin(checked);

        if (!checked) {
            setSelectedStationGroups([]);
        }
    }, []);

    const handleUpdate = async () => {
        const stationGroupValues = selectedStationGroups?.length > 0 ? selectedStationGroups.map((p) => p.value) : [];

        console.log("Selected Stations:", stationGroupValues);

         await dispatch(
             updateStationGroupAdmin({
               message: 'Status Updated.',
               payload: {
                 id: row.attributes.id,
                 type: 'user',
                 attributes: {
                   isStationAdmin:isGroupAdmin,
                   allotedStationGroups: stationGroupValues.join(','),
                   roles : isGroupAdmin ? ['group_admin','admin'] : ['admin'],
                 },
               },
             })
           );
           onClose();
    };

    const handleSelectChange = useCallback((newValue) => {
        setSelectedStationGroups(newValue || []);
    }, []);

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Manage Station Groups</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Toggle */}
                <div className="mb-3">
                    <Form.Check
                        type="switch"
                        id="station-admin-toggle"
                        label="Enable Group Admin"
                        checked={isGroupAdmin}
                        onChange={(e) => handleToggle(e.target.checked)}
                    />
                </div>

                {/* Multi Select */}
                {isGroupAdmin && (
                    <div className="mb-3">
                        <label className="form-label fw-bold">
                            Choose one or more Station Groups:
                        </label>
                        <Select
                            options={stationGroupsList}
                            value={selectedStationGroups}
                            onChange={handleSelectChange}
                            isMulti
                            placeholder="Select stations..."
                            menuPortalTarget={document.body} // Prevents layout issues
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                        />
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleUpdate}
                    disabled={isGroupAdmin && selectedStationGroups.length === 0}
                >
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RoleMangement;